import { Item } from "./Item";
import { BrokerTermsOfService } from "./BrokerTermsOfService";

export type DocumentType = "efl" | "yrac" | "tos";

export type DocumentListProps = {
  efl?: string;
  yrac?: string;
  tos?: string;
  hideBrokerTermsOfService?: boolean;
  onItemClick?: (document: DocumentType) => void;
};

export const DocumentList: React.FC<DocumentListProps> = ({
  efl,
  tos,
  yrac,
  hideBrokerTermsOfService,
  onItemClick,
}) => {
  return (
    <div className="flex flex-col gap-8">
      <Item
        title="Electricity Facts Label"
        href={efl ?? ""}
        onClick={() => onItemClick?.("efl")}
      />
      <Item
        title="Your Rights As a Customer"
        href={yrac ?? ""}
        onClick={() => onItemClick?.("yrac")}
      />
      <Item
        title="Terms of Service"
        href={tos ?? ""}
        onClick={() => onItemClick?.("tos")}
      />
      {!hideBrokerTermsOfService && <BrokerTermsOfService />}
    </div>
  );
};
